<template>
  <div>
    <Modal
      :width="500"
      :value="modalOpen"
      :title="modalData.title"
      :subtitle="modalData.subtitle"
      :cta-text="modalData.ctaText"
      :cancel-hidden="modalData.cancelHidden"
      @cancel="modalOpen = false"
      dialogIcon="danger"
      @confirm="confirmModal">
    </Modal>

    <ul class="tree">
      <QuizTreeNode
        @openModal="openModal"
        @item-drag-start="dragStart"
        @item-drag-end="dragEnd"
        @item-drop="drop"
        :drag-data="dragData"
        :tree="questionTree"
        :key="questionTree.root.intKey"
        :node.sync="questionTree.root"
        :parent="null"></QuizTreeNode>
    </ul>
  </div>
</template>

<script>
  import QuizTreeNode from "./QuizTreeNode.vue";
  import Modal from "@/components/custom/Modal.vue";

  export default {
    components: { QuizTreeNode, Modal },
    props: {
      questionTree: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        modalOpen: false,
        modalData: {},
        currentlyDraggedNode: null,
        dropTargetNode: null,
        dragging: false,
      };
    },
    computed: {
      dragData() {
        return {
          currentlyDraggedNode: this.currentlyDraggedNode,
          dropTargetNode: this.dropTargetNode,
          dragging: this.dragging,
        };
      },
    },
    methods: {
      openModal(data) {
        this.modalOpen = true;
        this.modalData = data;
      },
      confirmModal() {
        this.modalOpen = false;
        if (this.modalData.delete) {
          this.questionTree.removeNode(this.modalData.parent, this.modalData.node);
        }
      },
      dragStart(node) {
        this.dragging = true;
        this.currentlyDraggedNode = node;
      },
      dragEnd() {
        this.dragging = false;
        this.currentlyDraggedNode = null;
      },
      drop(node) {
        this.dropTargetNode = node;
        this.questionTree.copyNode(this.currentlyDraggedNode, this.dropTargetNode);
        this.dragging = false;
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/shortcodes.scss";
</style>
